import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
export var BrandDoesNotHaveInsiderFreeShippingIA = function BrandDoesNotHaveInsiderFreeShippingIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY(strictLocalize)];
    }
  };
};
var WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE = function WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE(strictLocalize) {
  return getSettingSelfServeRetailerTaxonomy() ? strictLocalize({
    id: "N937A2",
    defaultMessage: [{
      "type": 0,
      "value": "Een merk heeft niet meer Gratis verzending met Insider"
    }]
  }) : strictLocalize({
    id: "82J7WC",
    defaultMessage: [{
      "type": 0,
      "value": "Waarom heeft een merk waar ik eerder bij heb besteld geen gratis verzending met Insider meer\\?"
    }]
  });
};
var FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY = function FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY(strictLocalize) {
  return strictLocalize({
    id: "pKpa9D",
    defaultMessage: [{
      "type": 0,
      "value": "De dekking voor gratis verzending kan periodiek veranderen. De dekking kan bijvoorbeeld veranderen wanneer we aanpassingen maken op basis van geschatte kosten of wanneer we nieuwe factoren testen, zoals het type relatie. Dankzij deze flexibiliteit kunnen we gratis verzending bieden op zoveel mogelijk bestellingen, terwijl de prijs van je Insider-lidmaatschap betaalbaar blijft. Hoewel je gratis verzending met Insider hebt gekregen voor je laatste bestelling bij een specifiek merk, krijg je mogelijk niet langer gratis verzending met Insider met je lidmaatschap. Als je andere merken wilt vinden met gratis verzending met Insider, kun je het Insider-filter gebruiken tijdens het winkelen of gewoon zoeken naar de Insider-sleutel als je op Faire rondkijkt."
    }]
  });
};